"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const VenueOpeningHours_dto_1 = require("./VenueOpeningHours.dto");
class VenueDto {}
exports.VenueDto = VenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Google Places place id when known (no prefix). Used for photos / Google admin tools.'
}), __metadata("design:type", Object)], VenueDto.prototype, "googlePlaceId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Overture Maps GERS place id when linked (no prefix).'
}), __metadata("design:type", Object)], VenueDto.prototype, "overtureId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'OSM element id when linked, e.g. node/123 (no osm: prefix).'
}), __metadata("design:type", Object)], VenueDto.prototype, "osmId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, the venue should be hidden from map/discovery surfaces.'
}), __metadata("design:type", Object)], VenueDto.prototype, "isHidden", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'When true, the venue is permanently closed for visits (soft-close).'
}), __metadata("design:type", Object)], VenueDto.prototype, "isClosed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'ISO timestamp when the venue was closed; null when open.'
}), __metadata("design:type", Object)], VenueDto.prototype, "closedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Start of the admin-scheduled sponsored spotlight period; null when not scheduled.'
}), __metadata("design:type", Object)], VenueDto.prototype, "spotlightStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'End of the admin-scheduled sponsored spotlight period; null when not scheduled or open-ended.'
}), __metadata("design:type", Object)], VenueDto.prototype, "spotlightEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], VenueDto.prototype, "totalVisits", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "logoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "mapLogoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Optional admin-uploaded cover photo for the venue bottom sheet header. Null for most venues — the ' + 'client falls back to the logo/typed-icon gradient header.'
}), __metadata("design:type", Object)], VenueDto.prototype, "bannerUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: "The venue's Google Places photo (usually the storefront), copied once to our storage. The bottom sheet " + 'header uses it when there is no bannerUrl. Null until it has been fetched.'
}), __metadata("design:type", Object)], VenueDto.prototype, "storefrontUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Photographer credit Google requires next to storefrontUrl, e.g. "Jane Doe".'
}), __metadata("design:type", Object)], VenueDto.prototype, "storefrontAttribution", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'True when the venue has a custom/purchased logo (non-null logoUrl stored in DB).'
}), __metadata("design:type", Boolean)], VenueDto.prototype, "isPartnerVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], VenueDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "tikTokHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "instagramHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "facebookHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Number)], VenueDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Number)], VenueDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "totalCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Number of check-ins in the last 14 days (based on Visit.checkedInAt).'
}), __metadata("design:type", Object)], VenueDto.prototype, "recentCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Check-ins today (calendar day, server timezone), based on Visit.checkedInAt.'
}), __metadata("design:type", Object)], VenueDto.prototype, "checkInsTodayCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Whether the requesting user has checked into this venue (Visit.checkedInAt) within their own Footprints ' + 'history window (default 30 days; the field name is kept for wire compatibility even though the window ' + 'is now per-user). False (not omitted) when the user has Footprints disabled. Always false for an ' + 'unauthenticated/admin request.'
}), __metadata("design:type", Object)], VenueDto.prototype, "visitedInLast30Days", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Venue has an admin-scheduled sponsored period covering right now (see spotlightEligibility.rules.sponsored).'
}), __metadata("design:type", Object)], VenueDto.prototype, "isSponsored", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "matchingCheckins", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "RSVPs to active community events (venue specials) at this venue."
}), __metadata("design:type", Object)], VenueDto.prototype, "eventRsvpCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "Personal visit plans for today at this venue (server timezone)."
}), __metadata("design:type", Object)], VenueDto.prototype, "visitPlanCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: "RSVPs to events at this venue that are on today and haven't ended (server timezone). Added to visit plans for the map's Today's Plans filter."
}), __metadata("design:type", Object)], VenueDto.prototype, "todayEventRsvpCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "breadcrumbCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Count of active (non-expired, non-deleted) stickers posted at this venue.'
}), __metadata("design:type", Object)], VenueDto.prototype, "stickerCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDto.prototype, "distanceToBoundingBox", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDto.prototype, "distanceToCenter", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Number)], VenueDto.prototype, "visits", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "peeks", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "specials", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "aggregates", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", Object)], VenueDto.prototype, "zIndex", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Google Places photo reference (if available)'
}), __metadata("design:type", Object)], VenueDto.prototype, "photoReference", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: VenueOpeningHours_dto_1.VenueOpeningHoursDto,
  description: 'Effective opening hours (custom override when set, otherwise Google).'
}), __metadata("design:type", Object)], VenueDto.prototype, "openingHours", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  enum: enums_1.VenueOpeningHoursSource,
  nullable: true,
  description: 'Whether openingHours came from a manual override or Google Places.'
}), __metadata("design:type", Object)], VenueDto.prototype, "openingHoursSource", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'IANA timezone for interpreting opening hours (from Google when available).'
}), __metadata("design:type", Object)], VenueDto.prototype, "openingHoursTimezone", void 0);
//# sourceMappingURL=Venue.dto.js.map